import { DAIRY_FEED_ENERGY_UNIT, ENUM_DAIRY_FEED_ENERGY_UNIT, OrganicAmountUnit } from "models";

export const KG_PER_TONNE = 1000;

// These are also reused for beef
export const ENERGY_UNIT_DISPLAY_LABEL: Record<ENUM_DAIRY_FEED_ENERGY_UNIT, string> = {
  [DAIRY_FEED_ENERGY_UNIT.MJNEL]: "MJ NEL / kg DM",
  [DAIRY_FEED_ENERGY_UNIT.MJME]: "MJ ME / kg DM",
};

export const UNIT_DISPLAY_LABEL = {
  unknown: undefined,
  "%": "%",
  tonnes: "t",
  kilograms: "kg",
  cubic_meters: "m³",
  liters: "l",
  tonnes_per_ha: "t / ha",
  decitonnes_per_ha: "dt / ha",
  kilograms_N_per_cubic_meter: "kgN/m³",
  kilograms_N_per_tonne: "kgN/t",
  ...ENERGY_UNIT_DISPLAY_LABEL,
} as const;

export const getUnitDisplayLabel = (unit: string | null | undefined) => (unit ? UNIT_DISPLAY_LABEL[unit as never] ?? unit : "");

export const HARVEST_UNIT_VALUE = {
  tonnesPerHa: "tonnes_per_ha",
  decitonnesPerHa: "decitonnes_per_ha",
} as const;

export type HarvestUnitValue = "tonnes_per_ha" | "decitonnes_per_ha";

/**
 * How many of each unit make up one tonne.
 */
export const YIELD_UNITS_PER_TONNE: Record<HarvestUnitValue, number> = {
  [HARVEST_UNIT_VALUE.tonnesPerHa]: 1,
  [HARVEST_UNIT_VALUE.decitonnesPerHa]: 10,
};

/**
 * How many of each organic fertilizer unit make up one tonne. By convention organic fertilizer
 * has a density of 1 kg/L, so 1000 L (1 m³) weighs one tonne.
 */
export const ORGANIC_UNITS_PER_TONNE: Record<OrganicAmountUnit, number> = {
  tonnes: 1,
  cubic_meters: 1,
};

const UNITS_PER_TONNE: Record<HarvestUnitValue | OrganicAmountUnit, number> = { ...YIELD_UNITS_PER_TONNE, ...ORGANIC_UNITS_PER_TONNE };

/**
 * Normalizes a per-hectare amount (harvest yield or organic fertilizer) to tonnes/ha.
 * The harvest units mirror `toTonnesPerHa` in API; the organic fertilizer units are client-only.
 */
export const toTonnesPerHa = (value?: number | null, unit?: HarvestUnitValue | OrganicAmountUnit | null): number | null =>
  value === null || value === undefined ? null : value / (UNITS_PER_TONNE[unit ?? HARVEST_UNIT_VALUE.tonnesPerHa] ?? 1);
